module.exports = __webpack_public_path__ + "images/category_lp/macbook/assessment_achievements/3_5752459fd1d8d84b7ca87b4f5499a1fb.png";